import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
	name: string;
	value: string | number;
}

export const SFTPInputs = (props: Props): React.ReactElement => {
	const { name, value } = props;
	const { t } = useTranslation();

	return (
		<div className="d-flex align-items-center input-container mb-5">
			<div className="w-150px">{t(name)}:</div>
			<div className="text-truncate col-8 col-sm-9">{value}</div>
		</div>
	);
};
